import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UsersManagementPage = () => {
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    so: '',
    address: '',
    village: '',
    city: '',
    district: '',
    state: '',
    pin: '',
    role: '', // For team members
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://astrovidhya.in/api/users', {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      setError('Failed to fetch users. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleMobileEnter = async (mobile) => {
    try {
      const response = await axios.get(`https://astrovidhya.in/api/lookup/${mobile}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      const { type, data } = response.data;

      // Populate form data based on the type
      setFormData((prev) => ({
        ...prev,
        name: data.name,
        mobile: data.mobile,
        so: data.so || '',
        address: data.address || '',
        village: data.village || '',
        city: data.city || '',
        district: data.district || '',
        state: data.state || '',
        pin: data.pin || '',
        role: type === 'team-member' ? data.role : '', // Add role for team members
      }));
    } catch (error) {
      console.error('Error fetching data for mobile:', error);
      setError('No record found for this mobile number.');
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (name === 'mobile' && event.key === 'Enter') {
      handleMobileEnter(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('https://astrovidhya.in/api/users', formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      setUsers([...users, response.data]);
      alert('User added successfully!');
      setFormData({
        name: '',
        mobile: '',
        so: '',
        address: '',
        village: '',
        city: '',
        district: '',
        state: '',
        pin: '',
        role: '',
      });
    } catch (error) {
      console.error('Error adding user:', error);
      setError('Failed to add user. Please try again.');
    }
  };

  return (
    <div className="bg-gray-100 p-6 rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-6">Users Management</h1>

      {error && <p className="text-red-500">{error}</p>}

      {/* User Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-md mb-6 space-y-4"
      >
        <h2 className="text-xl font-semibold">Add New User</h2>
        <div className="grid grid-cols-2 gap-4">
        <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            className="p-2 border rounded"
            required
          />
          <input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            onKeyDown={handleChange}
            placeholder="Mobile"
            className="p-2 border rounded"
            required
          />
        
          <input
            type="text"
            name="so"
            value={formData.so}
            onChange={handleChange}
            placeholder="S/O"
            className="p-2 border rounded"
          />
           <input
            type="text"
            name="village"
            value={formData.village}
            onChange={handleChange}
            placeholder="Village"
            className="p-2 border rounded"
          />
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Address"
            className="p-2 border rounded"
          />
         
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="City"
            className="p-2 border rounded"
          />
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            placeholder="State"
            className="p-2 border rounded"
          />
         
          
          <input
            type="text"
            name="pin"
            value={formData.pin}
            onChange={handleChange}
            placeholder="PIN"
            className="p-2 border rounded"
          />
           <input
            type="text"
            name="district"
            value={formData.district}
            onChange={handleChange}
            placeholder="District"
            className="p-2 border rounded"
          />
       
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add User
        </button>
      </form>

      {/* User List */}
      {loading ? (
        <p>Loading users...</p>
      ) : (
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-4">User List</h2>
          <ul className="space-y-2">
            {users.map((user) => (
              <li
                key={user.mobile}
                className="p-4 bg-gray-50 rounded border hover:shadow"
              >
                <p>
                  <strong>{user.name}</strong> ({user.mobile})
                </p>
                <p>{user.address}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UsersManagementPage;
